import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
    return (_openBlock(), _createElementBlock("div", {
      id: `error-message-${index}`,
      key: error.$uid,
      class: "input-errors"
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(error.$message), 1)
    ], 8, _hoisted_1))
  }), 128))
}